import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { LOJAS_PADRAO } from "../constants/lojasOnline";

/* Tabela de comissão dos marketplaces, buscada na fonte oficial de cada loja
   uma vez por semana pela function `atualizarTaxasLojas` e publicada em
   config/taxasLojas (ver functions/taxasLojas/).

   Diferente de usePrecos, aqui EXISTE um valor embutido de plano B
   (LOJAS_PADRAO): um preço de assinatura errado cobra errado, mas uma
   calculadora que não abre não ajuda ninguém — e a tabela embutida está
   certa na data do build. O que a tela não pode é esconder de onde veio o
   número, por isso `origem` vem junto: "oficial" quando o job conseguiu ler
   a fonte, "embutida" quando caiu no plano B.

   onSnapshot mantém a tela em dia se o job rodar com o app aberto. */
const PLANO_B = { lojas: LOJAS_PADRAO, origem: "embutida", atualizadoEm: null, carregando: false };

export function useTaxasLojas() {
  const [tabela, setTabela] = useState({ ...PLANO_B, carregando: true });

  useEffect(() => onSnapshot(
    doc(db, "config", "taxasLojas"),
    (snap) => {
      const dados = snap.data();
      if (!Array.isArray(dados?.lojas) || !dados.lojas.length) return setTabela(PLANO_B);
      setTabela({
        lojas: dados.lojas,
        origem: "oficial",
        atualizadoEm: dados.atualizadoEm || null,
        carregando: false,
      });
    },
    () => setTabela(PLANO_B),
  ), []);

  return tabela;
}
